import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";
import {MonitoredChannel, MonitoredChannelSource} from "../../models/monitoredChannel";

export class MonitoredChannelDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.MONITOREDCHANNELS, apiHelper);
    }

    deleteBySource(source: MonitoredChannelSource) {
        let url = this.apiHelper.getServiceName() + this.getResource() + `/${source}`;
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'DELETE', null, null, headers);
    }

    createKantar(channels: MonitoredChannel | MonitoredChannel[]) {
        let url = this.apiHelper.getServiceName() + this.getResource() + '/kantar';
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, channels, headers);
    }

    createWWTV(channels: MonitoredChannel | MonitoredChannel[]) {
        let url = this.apiHelper.getServiceName() + this.getResource() + '/wwtv';
        let headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, channels, headers);
    }
}